import { formatCardDateTime } from "src/utils/formatUtils";

// --- Product Types ---

export const PRODUCT_TYPES: Record<number, string> = {
  1: "Reassigned Authority",
  2: "Reassigned Authority Plus",
  3: "Basic RND",
};

export const getProductName = (productId: number): string =>
  PRODUCT_TYPES[productId] || "Unknown";

// --- Submission Methods ---

export const SUBMISSION_METHODS: Record<string, string> = {
  a: "API",
  w: "Web",
  f: "SFTP",
};

export const getMethodLabel = (receivedBy: string): string =>
  SUBMISSION_METHODS[receivedBy] || receivedBy;

// --- Session Statuses ---

export const SESSION_STATUSES: Record<number, { name: string; badge: string }> =
  {
    1: { name: "Received", badge: "bg-secondary" },
    2: { name: "Imported", badge: "bg-info" },
    3: { name: "Queued", badge: "bg-warning text-dark" },
    4: { name: "Scrubbing", badge: "bg-info" },
    5: { name: "Finished Scrubbing", badge: "bg-info" },
    6: { name: "Generating Output", badge: "bg-info" },
    7: { name: "Completed", badge: "bg-success" },
    8: { name: "Cancelled", badge: "bg-secondary" },
    9: { name: "Identifying Reassigned Numbers", badge: "bg-info" },
    10: { name: "Exceeds Scrub Limit", badge: "bg-danger" },
    11: { name: "Invalid File Format", badge: "bg-danger" },
    12: { name: "Assistance Requested", badge: "bg-warning text-dark" },
    13: { name: "Rescrubbed", badge: "bg-success" },
    14: { name: "Retroscrubbed", badge: "bg-success" },
    15: { name: "Calculating billable records", badge: "bg-info" },
    16: { name: "Processing", badge: "bg-info" },
    17: { name: "Exceed Credit Limit", badge: "bg-danger" },
    18: { name: "Internal Error", badge: "bg-danger" },
    19: { name: "Pre-Signed Url Error", badge: "bg-danger" },
    20: { name: "Invalid File Header", badge: "bg-danger" },
    21: { name: "Invalid File Data", badge: "bg-danger" },
    22: { name: "File Empty", badge: "bg-danger" },
    23: { name: "File Exceed Size", badge: "bg-danger" },
    24: { name: "Exceed Max Limit", badge: "bg-danger" },
  };

export const getStatusInfo = (
  statusId: number,
): { name: string; badge: string } =>
  SESSION_STATUSES[statusId] || { name: "Unknown", badge: "bg-secondary" };

// --- Formatting ---

export const formatTimestamp = (timestamp: string | null): string => {
  if (!timestamp) return "-";
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "-";
    return formatCardDateTime(timestamp);
  } catch {
    return "-";
  }
};
